import { Injectable, Inject, PLATFORM_ID, ApplicationRef } from '@angular/core';

import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { ResponseService } from './response/response.service';
import { filter, delay, take } from 'rxjs/operators';



/**
 * The purpose of this service is solely for server rendering purposes for SEO.
 * This service will set the window.prerenderready=true to notify the server rendering that the page is ready to displayed, so we don't have to wait for every call to finish before displaying the page
 * All top level routes will have this service
 *
 */
@Injectable()
export class PreRenderService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private appRef: ApplicationRef,
    private responseService: ResponseService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      appRef.isStable.pipe(
          filter(stable => stable),
          delay(3000),
          take(1))
          .subscribe(() => {
          
            this.onAppStable();
        });
    }
  }

  get isServerMode(): boolean {
    return isPlatformServer(this.platformId);
  }

  get isBrowserMode(): boolean {
    return isPlatformBrowser(this.platformId);
  }


  private onAppStable() {
    if (this.isServerMode) {
      return;
    }
    //const dom = getDOM();
    const styles: any[] =
        Array.prototype.slice.apply(document.querySelectorAll(`style[ng-transition-rmx]`));
    styles.filter(el => el.getAttribute('ng-transition-rmx') === "remaxdotca")
        .forEach(el => el.remove());
  }

  /**
   * Sets the window.prerenderready=true for server rendering purposes
   * @param statusCode
   * @param redirectUrl?
   */
  setPreRenderFlag(statusCode: number, redirectUrl?: string) {
    //this.setResponseCode(statusCode, redirectUrl);

    if (!this.isServerMode) {
      return;
    }

    this.responseService.setResponseCode('' + statusCode, redirectUrl);
  }

}
